export default __webpack_public_path__ + "static/media/266.746cbf57.jpg";